import * as React from "react";

/**
 * Instant-quote icon: a protection shield containing three ascending bars —
 * "compare rates across carriers". Replaces the generic lucide `Sparkles` on the
 * quote button, which read as decorative AI filler rather than describing the action.
 *
 * Lucide-compatible API (`size`, `strokeWidth`, `className`) and strokes in
 * currentColor, so it drops in wherever a lucide icon was used. Matches the
 * conventions in [[LeadSniperIcon]] / [[InsuraBotIcon]].
 *
 * Sized for small render targets — the button uses h-3.5 (14px), so the bars are
 * kept wide-set and the shield outline simple. Extra interior detail turns to mush
 * below ~16px.
 */
export function QuoteCompareIcon({
  size = 24,
  strokeWidth = 2,
  className,
  ...props
}: {
  size?: number;
  strokeWidth?: number;
  className?: string;
} & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* protection shield */}
      <path d="M12 2.5 20 5.5v6c0 4.4-3.3 7.8-8 9.4-4.7-1.6-8-5-8-9.4v-6z" />
      {/* ascending rate bars — cheapest to richest */}
      <line x1="9" y1="15" x2="9" y2="13" />
      <line x1="12" y1="15" x2="12" y2="11" />
      <line x1="15" y1="15" x2="15" y2="9" />
    </svg>
  );
}

export default QuoteCompareIcon;
